import dayjs from "dayjs";
import utc from "dayjs/plugin/utc.js";
import timezone from "dayjs/plugin/timezone.js";
import "dayjs/locale/zh-tw";

// 與 src/i18n.js 初始化的是同一個 i18next 實例
import i18n from "i18next";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.locale("zh-tw");

// # 時間一律以台北時區顯示；星期等文字跟著目前語言（英文顯示 Fri，中文顯示 週五）
export const convertTimeStamp = (
  dateTime,
  formatString = "YYYY-MM-DD HH:mm"
) => {
  // 尚未載入或後端沒給值時，不要顯示成 1970/01/01 或 Invalid Date
  if (dateTime === null || dateTime === undefined || dateTime === "") {
    return "-";
  }
  const locale = i18n.language === "en" ? "en" : "zh-tw";
  return dayjs
    .unix(dateTime)
    .tz("Asia/Taipei")
    .locale(locale)
    .format(formatString);
};
